module.exports = __webpack_public_path__ + "static/media/cross.57e43d77.svg";